import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { appName } from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Helmet } from "react-helmet";
import { Row, Col, Table, Modal } from 'react-bootstrap';
import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";
import Roles from '../../../utils/Roles';
import swal from 'sweetalert';
import Pagination from "react-js-pagination";
import Renew from './Renew';
import PageTitle from '../../../containers/PageTitle';
const td_bggreen = { backgroundColor: '#b6ecc3' };
const td_bgwhite = { backgroundColor: 'white' };
class Renewal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			loginText: 'LOGIN',
			isRedirect: false,
			showAddModal: false,
			showEditModal: false,
			currentPage: 1,
			todosPerPage: 10,
			activePage: 1,
			dataList: [],
			dataView: [],
			editData: [],
			deptList: [],
			reList: [],
			showModal: false,
			rData: [],
		}

		this.handleSearch = this.handleSearch.bind(this);
		this.loadEmployees = this.loadEmployees.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onView = this.onView.bind(this);
		this.onRefresh = this.onRefresh.bind(this);
	}

	onRefresh(e) {
		this.loadEmployees();
		this.setState({ showModal: false, rData: [] });
	}

	onRenew(index, e) {
		this.setState({ showModal: !this.state.showModal, rData: this.state.dataList[index] });
	}

	onhandleChange(e) {
		this.setState({ dataList: [] });
		//this.state.dept = e.target.value;
		this.setState({ [e.target.name]: e.target.value })
	}

	onView(e) {
		this.loadEmployees();
	}

	componentDidMount() {

		this.loadRenewMonth();
		this.loadDepartments();

	}

	loadDepartments() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('postcategory/getactivecategories/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ deptList: res['data'].data });
				this.setState({ showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	loadRenewMonth() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('acyear/getrenewmonth/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ reList: res['data'].data });
				this.setState({ showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	loadEmployees() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('employee/getEmployeeListBydept/' + this.state.dept + '/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ dataList: res['data'].data, dataFilter: res['data'].data, showLoader: false });

			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	handleSearch(e) {
		try {
			var list = this.state.dataFilter;
			var v = e.target.value.toUpperCase();
			var l = list.filter(function (obj) {
				const name = obj.name.toUpperCase();
				const mobile = obj.mobile.toUpperCase();
				const catname = obj.categoryname.toUpperCase();
				return ((name.indexOf(v) > -1) || (mobile.indexOf(v) > -1) || (catname.indexOf(v) > -1));
			});
			this.setState({ dataList: l });
		}
		catch (error) {
			console.log(error);
		}
	}

	handleEdit(id, e) {
		var list = this.state.dataView;
		var index = list.findIndex(function (obj) { return obj.id == id });
		var l = list[index];
		this.setState({ editData: l, showEditModal: true });
	}

	removeValue(id, e) {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('employee/removeprofile/' + this.state.masterId + '/' + this.state.companyId + '/' + id + '/' + token).then(res => {
			if (res['data'].status == '1') {
				var l = this.state.dataList;
				var index = l.findIndex(function (obj) {
					return (obj.id == id);
				});
				l.splice(index, 1);
				this.setState({ dataList: l, dataView: l, showLoader: false });
				notify.show(res['data'].msg, 'success');
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	handleRemoveClick(id, e) {

		swal({ title: 'Confirm', text: 'Do you want to Delete?', buttons: ['No', 'Yes'] }).then((willYes) => {
			if (willYes) this.removeValue(id, e);
		});

	}

	handlePageChange(pageNumber) {

		this.setState({ activePage: pageNumber });
		this.state.currentPage = Number(pageNumber);
	}


	renewValue(id, e) {
		swal({
			title: 'Confirm',
			text: 'Do you want to Renewal?',
			buttons: ['No', 'Yes']
		}).then((willYes) => {
			if (willYes) {
				var token = Reqst.TimeStamp();
				Reqst.axGet('employee/renewprofile/' + this.state.masterId + '/' + this.state.companyId + '/' + id + '/' + token).then(res => {
					if (res['data'].status == '1') {
						var l = this.state.dataList;
						var index = l.findIndex(function (obj) {
							return (obj.id == id);
						});
						l.splice(index, 1);
						this.setState({ dataList: l, dataView: l, showLoader: false });
						notify.show(res['data'].msg, 'success');
					}
					else {
						notify.show(res['data'].msg, 'error');
						this.setState({ showLoader: false });
					}
				});
			}
		});
	}


	/*	onhandleChange(e) {
			try {
				var list = this.state.dataList;
				var v = e.target.value;
				if (v == '') {
					this.setState({ dataView: list });
				}
				else {
					var l = list.filter(function (obj) {
						const catname = obj.post_category;
						return (catname == v);
					});
					this.setState({ dataView: l });
				}
			}
			catch (error) {
				console.log(error);
			}
		}*/



	render() {

		const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		const currentTodos = this.state.dataList//.slice(indexOfFirstTodo, indexOfLastTodo);
		let sno = indexOfFirstTodo + 1;

		var today = new Date();
		var preyear = today.getFullYear() - 2;
		var curyear = today.getFullYear();

		let YearList = [];
		YearList.push(<option value="">Select Renew Year</option>);
		for (var i = ((new Date()).getFullYear()); i >= ((new Date()).getFullYear()); i--) {
			YearList.push(<option value={i}> {i} </option>);
		}

		return (
			<div>
				<Helmet>
					<title>{appName} | Candidate List For Renewal</title>
				</Helmet>

				<PageTitle title="Candidate List For Renewal" style={{ border: 'none' }} loading={this.state.showLoader} >

				</PageTitle>
				<div style={{ marginTop: '35px', border: 'none', paddingTop: '5px', paddingBottom: '5px' }} className='page-header'>
					<Row>
						<Col md={2}>
							<select name="ryear" className="form-control input-sm" onChange={this.onhandleChange.bind(this)}>
								<option value="">Select M&Y</option>
								{this.state.reList.map((item, i) =>
									<option value={item.renewmonth} >{Sanitize.dateTomonth(item.renewmonth)}</option>
								)}
							</select>
						</Col>
						<Col md={2} >
							<select name="dept" className="form-control input-sm" onChange={this.onhandleChange.bind(this)}>
								<option value="">Select Category</option>
								{this.state.deptList.map((item, i) =>
									<option value={item.id} >{item.categoryname}</option>
								)}
							</select>
						</Col>
						<Col md={1}>
							<button type="submit" className="btn btn-primary btn-sm" onClick={this.onView} >
								<i className="fa fa-check"></i> View
						</button>
						</Col>
						<Col md={3} >
							<input type="text" className="form-control input-sm" placeholder="Search Name Here..." onChange={this.handleSearch} />
						</Col>
					</Row>
				</div><br /><br /><br />
				<Row>
					<Col md={12} >
						<Table hover responsive className="list-table" >
							<thead>
								<tr>
									{/*<th width="60" >SR.No</th>*/}
									<th>Registration Year</th>
									<th width="120">Year of Passing</th>
									<th>Candidate Name</th>
									<th>Address</th>
									<th width="90">Mobile</th>
									<th>Renew</th>
								</tr>
							</thead>
							<tbody>
								{Object.keys(currentTodos).length > 0 ?
									currentTodos.map((item, key) => {
										return <tr key={key} style={(Sanitize.getDobYear(item.lastrenew_year) === Sanitize.getDobYear(this.state.ryear) ? td_bggreen : td_bgwhite)}>
											{/*<td>{item.seniority}</td>*/}
											<td>{item.for_year}</td>
											<td>{Sanitize.getMonthName(item.passmonth)} {item.passyear} <br />{Sanitize.dateTomonth(item.sptraining_year)}</td>
											<td>{item.name}<br />{item.splcategory != '' && item.splcategory != null ? '(' + item.splcategory + ')' : ''}</td>
											<td>{item.address} - {item.pincode}</td>
											<td>{item.mobile}</td>
											{Sanitize.getDobYear(item.lastrenew_year) != Sanitize.getDobYear(this.state.ryear) ?
												<td align="center" >
													<button className="btn btn-info btn-sm btn-lowpadding" onClick={this.onRenew.bind(this, key)}>
														<i className="fa fa-eye"></i>
													</button>&nbsp;&nbsp;
												</td> : <td align="center" ><span style={{ fontWeight: 'bold' }}>Renewed</span>
												</td>}
										</tr>;
									})
									: <tr>
										<td colSpan="10" align="center" style={{ fontSize: '18px', color: 'brown' }}>
											No data found..!
								</td>
									</tr>
								}
							</tbody>
						</Table>
					</Col>
				</Row>
				<Modal size="lg" show={this.state.showModal} onHide={() => { this.setState({ showModal: false }) }} className="" >
					<Modal.Header closeButton >
						<Modal.Title>Profile</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Renew rData={this.state.rData} rYear={this.state.ryear} afterFinish={this.onRefresh.bind(this)} />
					</Modal.Body>
				</Modal>
			</div>
		);
	}

}
export default Renewal;